var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "live-video-streming-component",
      class: [
        _vm.liveStreamProvider,
        {
          perform:
            _vm.performVisuality &&
            _vm.liveStreamProvider === "PER2" &&
            _vm.visualAndVideo.length > 1 &&
            !_vm.isMobile
        }
      ]
    },
    [
      _vm.videoSrc === "notLoggedIn"
        ? _c("div", { staticClass: "error" }, [
            _c("span", { key: _vm.liveStreamProvider + Math.random() }, [
              _vm._v(_vm._s(_vm.$t("VideoStreaming.notloggedIn.Message")))
            ])
          ])
        : _vm.videoSrc === "noStreamAvailable"
        ? _c(
            "div",
            {
              key: _vm.liveStreamProvider + Math.random(),
              staticClass: "error"
            },
            [_vm._v(_vm._s(_vm.$t("VideoStreaming.noStreamAvailable.Message")))]
          )
        : _vm.videoSrc === "noMoneyOrNoPlacedBet"
        ? _c(
            "div",
            {
              key: _vm.liveStreamProvider + Math.random(),
              staticClass: "error"
            },
            [
              _vm._v(
                _vm._s(_vm.$t("VideoStreaming.noMoneyOrNoPlacedBet.Message"))
              )
            ]
          )
        : _vm.videoSrc === "hlsNotSupported"
        ? _c(
            "div",
            {
              key: _vm.liveStreamProvider + Math.random(),
              staticClass: "error"
            },
            [_vm._v(_vm._s(_vm.$t("VideoStreaming.hlsNotSupported.Message")))]
          )
        : _vm.videoSrc === "error"
        ? _c(
            "div",
            {
              key: _vm.liveStreamProvider + Math.random(),
              staticClass: "error"
            },
            [_vm._v(_vm._s(_vm.$t("VideoStreaming.error.Message")))]
          )
        : _vm.videoSrc === "noStateEligibleToWatch"
        ? _c(
            "div",
            {
              key: _vm.liveStreamProvider + Math.random(),
              staticClass: "error"
            },
            [_vm._v(_vm._s(_vm.$t("VideoStreaming.notEligibleState.Message")))]
          )
        : _vm.videoSrc
        ? [
            _c(
              "div",
              { attrs: { id: "liveplayer" } },
              [
                _vm.liveStreamProvider === "BRD"
                  ? [
                      _c(
                        "video",
                        {
                          attrs: {
                            preload: "auto",
                            autoplay: "autoplay",
                            playsinline: "",
                            controls: ""
                          }
                        },
                        [
                          _c("source", {
                            attrs: {
                              src: _vm.videoSrc,
                              type: "application/x-mpegURL"
                            }
                          })
                        ]
                      )
                    ]
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _vm.liveStreamProvider === "IMG"
              ? [
                  this.videoSrc !== null && this.videoSrc !== "error"
                    ? _c("video", {
                        attrs: {
                          id: "plyrPlayer",
                          playsinline: "",
                          autoplay: "",
                          muted: "",
                          loop: "",
                          crossorigin: "",
                          type: "application/dash+xml"
                        },
                        domProps: { muted: true }
                      })
                    : _vm._e()
                ]
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.performVisuality,
                expression: "performVisuality"
              }
            ]
          },
          [_c("div", { ref: "scriptHolder" })]
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d343fb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d343fb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/live/LiveVideoStreaming.vue
// module id = null
// module chunks = 